/* EvridWear: accessible fallback for legacy shoppable-image hotspots in Craft. */
(() => {
  const rootSelector = '[id$="__shoppable_image_JeCjNw"]';
  const close = (root, except) => {
    root.querySelectorAll('hotspot-button.hotspot[data-open="true"]').forEach((spot) => {
      if (spot === except) return;
      spot.dataset.open = 'false';
      const button = spot.querySelector('.hotspot-btn');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const root = target.closest(rootSelector);
    if (!root) {
      document.querySelectorAll(rootSelector).forEach(section => close(section));
      return;
    }
    const button = target.closest('hotspot-button.hotspot .hotspot-btn');
    if (!button) {
      if (!target.closest('.hotspot__content')) close(root);
      return;
    }
    // Leave behavior to the legacy component if a theme app registered it.
    if (window.customElements && customElements.get('hotspot-button')) return;
    event.preventDefault();
    const spot = button.closest('hotspot-button.hotspot');
    const shouldOpen = spot.dataset.open !== 'true';
    close(root, spot);
    spot.dataset.open = String(shouldOpen);
    button.setAttribute('aria-expanded', String(shouldOpen));
    button.setAttribute('aria-label', shouldOpen ? 'Close product details' : 'Show product details');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll(rootSelector).forEach(section => close(section));
  });
})();
